import React from "react"

const SingleAiSparkle = (props: React.SVGProps<any>) => {
  return (
    <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M11.5519 5.97985C8.54555 5.99481 6.11136 8.42905 6.09654 11.4353C6.08157 8.42906 3.64712 5.99494 0.640786 5.98012C3.64717 5.96518 6.08136 3.53084 6.09614 0.524551C6.11106 3.53084 8.5455 5.96506 11.5519 5.97985Z" />
    </svg>
  )
}

export default SingleAiSparkle
